import type { INavigationService } from "@/application/ports/INavigationService";
import { getNavigationService } from "@/infrastructure/di";

export function useNavigationService(): INavigationService {
  return getNavigationService();
}
